// Froala config overrides that make composed email HTML cleaner for
// deliverability (ENGI-3298): plain-text paste and a whitelist of structural
// tags. Do NOT add useClasses: false — in Froala 2.x it inlines the editor
// UI's computed CSS (app fonts, box-sizing) into the content and leaves
// fr-original-style attributes behind.
const froalaEmailCleanupConfig = {
  pastePlain: true,
  htmlAllowedTags: [
    'p',
    'div',
    'br',
    'strong',
    'b',
    'em',
    'i',
    'u',
    'a',
    'ul',
    'ol',
    'li',
    'span',
    'h1',
    'h2',
    'h3',
    'h4',
    'table',
    'thead',
    'tbody',
    'tfoot',
    'tr',
    'td',
    'th',
    'blockquote',
    'sub',
    'sup',
    'hr',
  ],
  // Kept alongside pastePlain on purpose: Froala 2.x still runs the paste
  // filters when pastePlain is on (verified — pasteDeniedAttrs stripped
  // classes in testing), and htmlAllowedTags alone proved unreliable on the
  // paste path (htmlAllowedStyleProps is ignored there).
  pasteDeniedTags: ['style', 'script', 'meta', 'link', 'img'],
}

export default froalaEmailCleanupConfig
